/* eslint-disable react/jsx-one-expression-per-line */
import { PiSpeakerSimpleHighFill } from 'react-icons/pi';
import { QuestionComponentProps } from '../type';

const HeaderCommon = ({ questionIndex, questionData, isCombineChild }: QuestionComponentProps) => {
  if (isCombineChild) {
    return null;
  }
  return (
    <div className='tw-mb-4'>
      <div>
        {questionIndex + 1}. {questionData.audioUrl ? <PiSpeakerSimpleHighFill style={{ marginLeft: 5 }} /> : ''} {questionData.title}
      </div>
      {/* Khách hàng không muốn hiển thị tiêu đề tiếng việt */}
      {/* <div style={{ fontSize: '0.875rem' }}>{questionData.subTitle ? <i>({questionData.subTitle})</i> : null}</div> */}
    </div>
  );
};
const QuestionNumber = ({ isCombineChild, questionIndex }: { isCombineChild: boolean; questionIndex: number }) => {
  if (isCombineChild) {
    return <i>{questionIndex + 1}. </i>;
  }
  return null;
};

export const revertHtmlFromQuill = (html: string): string => {
  if (!html) return '';

  return (
    html
      // replace ql-align-center class with inline style
      .replace(/<p\s+class="ql-align-center">(.*?)<\/p>/gi, '<p style="text-align: center; margin-bottom: 10px">$1</p>')
      // optional: if you also want to revert <strong> to <b> and <em> to <i>
      .replace(/<strong>/gi, '<b>')
      .replace(/<\/strong>/gi, '</b>')
      .replace(/<em>/gi, '<i>')
      .replace(/<\/em>/gi, '</i>')
  );
};

const QuestionText = ({ questionText }: { questionText: string }) => {
  // Bỏ thẻ <p> để tránh dính css bên ngoài
  const htmlStringFormated = revertHtmlFromQuill(questionText).replaceAll('<p', '<div').replaceAll('</p>', '</div>');
  // Render HTML
  return <div className='tw-mb-4' style={{ display: 'inline-block', width: '100%' }} dangerouslySetInnerHTML={{ __html: htmlStringFormated }} />;
};

export { HeaderCommon, QuestionNumber, QuestionText };
